// extracted by mini-css-extract-plugin
export default {"vote":"Home_vote__8Rkae","movie":"Home_movie__PXiZU","data":"Home_data__FaLjN","tv":"Home_tv__h5YWQ","title":"Home_title__Y6zeg"};